import { AiBlockType } from '@/levity/aiblocks/types';
import { IntegrationAuthApp } from '@/levity/integrations/types';

import { DYNAMIC_EDITOR_TAG_EXTENSION_NAME } from '../../../../components/dynamic-input/constants';
import { ZendeskKey } from '../../../integrations/registry/customer-service/providers/zendesk.core';
import { zendeskOperationsDefinition } from '../../../integrations/registry/customer-service/providers/zendesk.definition';
import { AppNodeType, FlowNodeType, type FlowTemplate } from '../../types';

export const classifyTickets: FlowTemplate = {
  name: 'classify-tickets-by-tag',
  description: 'Classify incoming Zendesk tickets and update ticket tags',
  integrations: [IntegrationAuthApp.zendeskV1],
  title: 'Classify incoming Zendesk tickets and update ticket tags',
  nodes: [
    {
      id: 'b6193217-f4d9-42f4-9f82-c040eb87d92d',
      type: FlowNodeType.APP,
      icon: `/imgs/icons/${IntegrationAuthApp.zendeskV1}.svg`,
      metadata: {
        integration: IntegrationAuthApp.zendeskV1,
        type: AppNodeType.TRIGGER,
        operationId: zendeskOperationsDefinition.GetTickets.id,
      },
    },
    {
      id: '23377be4-f0da-40d2-9b55-20cd4ba9e138',
      type: FlowNodeType.AI_BLOCK,
      icon: `/imgs/icons/aiblocks/${AiBlockType.classify}.svg`,
      metadata: {
        aiBlockId: 'dd2dbd75-b17e-402d-a060-99ca07dbce48',
      },
      defaultDynamicInputContent: [
        {
          type: DYNAMIC_EDITOR_TAG_EXTENSION_NAME,
          attrs: {
            dynamicTag: {
              operation: zendeskOperationsDefinition.GetTickets.id,
              key: ZendeskKey.TICKET_DESCRIPTION,
              image: {
                alt: 'Zendesk application icon',
                src: `/imgs/icons/${IntegrationAuthApp.zendeskV1}.svg`,
              },
            },
          },
        },
      ],
    },
    {
      id: 'ced2200d-1e28-4d73-97fd-a2ce825e52c2',
      type: FlowNodeType.APP,
      icon: `/imgs/icons/${IntegrationAuthApp.zendeskV1}.svg`,
      metadata: {
        integration: IntegrationAuthApp.zendeskV1,
        type: AppNodeType.TARGET,
        operationId: zendeskOperationsDefinition.UpdateTicketTags.id,
      },
      defaultDynamicInputContent: [
        {
          type: DYNAMIC_EDITOR_TAG_EXTENSION_NAME,
          attrs: {
            dynamicTag: {
              operation: 'llm-classify-with-block-labels',
              key: 'Classification Result',
              image: {
                alt: 'llm application icon',
                src: `/imgs/icons/aiblocks/${AiBlockType.classify}.svg`,
              },
            },
          },
        },
      ],
    },
  ],
  edges: [
    {
      sourceHandle: 'source',
      targetHandle: 'target',
      sourceId: 'b6193217-f4d9-42f4-9f82-c040eb87d92d',
      targetId: '23377be4-f0da-40d2-9b55-20cd4ba9e138',
    },
    {
      sourceHandle: 'source',
      targetHandle: 'target',
      sourceId: '23377be4-f0da-40d2-9b55-20cd4ba9e138',
      targetId: 'ced2200d-1e28-4d73-97fd-a2ce825e52c2',
    },
  ],
  aiBlocks: [
    {
      id: 'dd2dbd75-b17e-402d-a060-99ca07dbce48',
      name: 'Classify ticket',
      emoji: '🦋',
      type: AiBlockType.classify,
    },
  ],
};
